// extracted by mini-css-extract-plugin
export default {"Text":"iteration-diff-value-module__Text--udHD1","Text_1":"iteration-diff-value-module__Text_1--BmK2Z","Text_2":"iteration-diff-value-module__Text_2--nmEEf"};